/**
 * @generated SignedSource<<651579a390cac070f7d7368e32cc3ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActivateSageIntacctInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type activateSageIntacctMutation$variables = {
  input: ActivateSageIntacctInput;
};
export type activateSageIntacctMutation$data = {
  readonly activateSageIntacct: {
    readonly outcome: string | null;
    readonly company: {
      readonly id: string;
      readonly sageIntacctEnabled: boolean | null;
      readonly workatoCustomerId: string | null;
      readonly workatoForecastSageIntacctConnectionId: string | null;
      readonly workatoSageIntacctConnectionId: string | null;
      readonly workatoIframeToken: string | null;
    } | null;
  } | null;
};
export type activateSageIntacctMutation = {
  variables: activateSageIntacctMutation$variables;
  response: activateSageIntacctMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ActivateSageIntacctPayload",
    "kind": "LinkedField",
    "name": "activateSageIntacct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sageIntacctEnabled",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoCustomerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoForecastSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoSageIntacctConnectionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "workatoIframeToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "activateSageIntacctMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "activateSageIntacctMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e0b98d15810b96053f05ff1f776ad3c",
    "id": null,
    "metadata": {},
    "name": "activateSageIntacctMutation",
    "operationKind": "mutation",
    "text": "mutation activateSageIntacctMutation(\n  $input: ActivateSageIntacctInput!\n) {\n  activateSageIntacct(input: $input) {\n    outcome\n    company {\n      id\n      sageIntacctEnabled\n      workatoCustomerId\n      workatoForecastSageIntacctConnectionId\n      workatoSageIntacctConnectionId\n      workatoIframeToken\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "adce9a6de6c069b858ae3c10628eeeb4";

export default node;
